import { ReelSymbol } from "@lib/titan2-slingo/dist/game/view/abstract/display/ReelSymbol";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
var ReelSymbolAnims;
(function (ReelSymbolAnims) {
    ReelSymbolAnims["CASH_LAND"] = "0-cash-land";
    ReelSymbolAnims["CASH_STATIC"] = "0-cash-static";
    ReelSymbolAnims["CASH_COLLECT"] = "0-cash-collect";
    ReelSymbolAnims["FREESPINS_LAND"] = "0-freespins-land";
    ReelSymbolAnims["FREESPINS_STATIC"] = "0-freespins-static";
    ReelSymbolAnims["FREESPINS_COLLECT"] = "0-freespins-collect";
    ReelSymbolAnims["FREESPINS_COLLECTED"] = "0-freespins-collected";
    ReelSymbolAnims["SUPER_WILD_LAND"] = "0-super-wild-land";
    ReelSymbolAnims["SUPER_WILD_STATIC"] = "0-super-wild-static";
    ReelSymbolAnims["SUPER_WILD_ACTIVE"] = "0-super-wild-active";
    ReelSymbolAnims["VALUE_LAND"] = "0-value-land";
    ReelSymbolAnims["VALUE_STATIC"] = "0-value-static";
    ReelSymbolAnims["VALUE_MATCH"] = "0-value-match";
    ReelSymbolAnims["WILD_LAND"] = "0-wild-land";
    ReelSymbolAnims["WILD_ACTIVE"] = "0-wild-active";
    ReelSymbolAnims["WILD_STATIC"] = "0-wild-static";
    ReelSymbolAnims["BLOCKER_LAND"] = "0-blocker-land";
    ReelSymbolAnims["BLOCKER_STATIC"] = "0-blocker-static";
})(ReelSymbolAnims || (ReelSymbolAnims = {}));
/**
 * GameReelSymbol.ts
 */
export class GameReelSymbol extends ReelSymbol {
    constructor(landscapeProperties, portraitProperties, reelProperties) {
        super(landscapeProperties, portraitProperties, reelProperties);
        this.reelProperties = reelProperties;
    }
    play() {
        //nop
    }
    gotoAndStop() {
        SpineUtil.stop(this.spine);
    }
    strikeDevil() {
        SpineUtil.play(this.spine, ReelSymbolAnims.BLOCKER_LAND);
    }
    strikeJoker() {
        SpineUtil.play(this.spine, ReelSymbolAnims.WILD_LAND);
    }
    loopJoker() {
        SpineUtil.playLoop(this.spine, ReelSymbolAnims.WILD_ACTIVE);
    }
    strikeJokerFullyDabbed() {
        SpineUtil.play(this.spine, ReelSymbolAnims.WILD_STATIC);
    }
    strikeSuperJoker() {
        SpineUtil.play(this.spine, ReelSymbolAnims.SUPER_WILD_LAND);
    }
    loopSuperJoker() {
        SpineUtil.playLoop(this.spine, ReelSymbolAnims.SUPER_WILD_ACTIVE);
    }
    strikeFreeSpin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.FREESPINS_LAND);
    }
    collectFreeSpin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.FREESPINS_COLLECT);
    }
    strikeNumber() {
        SpineUtil.play(this.spine, ReelSymbolAnims.VALUE_LAND);
    }
    stopNumber() {
        SpineUtil.play(this.spine, ReelSymbolAnims.VALUE_STATIC);
    }
    collectNumber() {
        SpineUtil.play(this.spine, ReelSymbolAnims.VALUE_MATCH);
    }
    strikeCoin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.CASH_LAND);
    }
    stopDevil() {
        SpineUtil.play(this.spine, ReelSymbolAnims.BLOCKER_STATIC);
    }
    stopCoin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.CASH_STATIC);
    }
    stopJoker() {
        SpineUtil.play(this.spine, ReelSymbolAnims.WILD_STATIC);
    }
    stopSuperJoker() {
        SpineUtil.play(this.spine, ReelSymbolAnims.SUPER_WILD_STATIC);
    }
    stopFreeSpin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.FREESPINS_COLLECTED);
    }
    collectCoinWin() {
        SpineUtil.play(this.spine, ReelSymbolAnims.CASH_COLLECT);
    }
}
//# sourceMappingURL=GameReelSymbol.js.map